import React from "react";
import ReportTable from "../../ReportTable/Table/ReportTable";
import Notification from "../../../shared/items/static/notification";
import ReportNoDataInfo from "./reportNoDataInfo";

const ReportTableResult = (props) => {
  const { report, onSetSctollUnitReport, scrollPositions, unitId, unitsReportData } = props;

  const data = unitsReportData.units.filter((x) => {
    return x.info.id === unitId;
  })[0];

  if (data === undefined) {
    return (
      <Notification type="warning" styles={{ heigth: "40px" }}>
        <p>{`Данные по ТС не запрошены`}</p>
      </Notification>
    );
  }

  if (data.data.info === undefined) return null;
  
  if (data.tableData.days !== undefined && data.tableData.days.length === 0) {
    return <ReportNoDataInfo info={data.data.info} />;
  }

  const scroll = scrollPositions.filter((x) => {
    return x.id === unitId;
  })[0];

  return (
    <ReportTable
      key={report.id + data.data.info.id}
      unitId={data.data.info.id}
      data={data.tableData}
      fields={report.fields}
      scroll={scroll !== undefined ? scroll.scroll : 0}
      onSetSctollUnitReport={onSetSctollUnitReport}
    />
  );
};

export default React.memo(ReportTableResult);